export default "/_next/static/01912319b0e7f0a4704634f8509eadef.png";